import { render, staticRenderFns } from "./AlterarDadosAtendente.vue?vue&type=template&id=96606476&scoped=true"
import script from "./AlterarDadosAtendente.vue?vue&type=script&lang=js"
export * from "./AlterarDadosAtendente.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosAtendente.vue?vue&type=style&index=0&id=96606476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96606476",
  null
  
)

export default component.exports